module.exports = __webpack_public_path__ + "static/media/rawpixel-comm.9fb6ea21.jpg";